import styled from "styled-components";
import { colors } from "../../../theme/color";
import fipayFonts from "../../../theme/index";

export const PreviewOfPaymentModalWrapper = styled.div`
  width: 100%;
  // height: 98vh;
  // @media screen and (min-width: 768px) {
  //   margin-top: 40px;

  // }
`;

export const PreviewOfPaymentModalContainer = styled.div`
  width: 487px;
  /* margin: 0 auto; */
  padding-top: 30px;
  padding-bottom: 20px;
  background-color: #ecebf2;

  @media screen and (max-width: 1280px) {
    // height: 110vh;
  }

  @media screen and (max-width: 1024px) {
    // height: 850px;
  }

  @media screen and (max-height: 600) {
    // height: 150vh;
  }

  @media screen and (max-width: 375px) {
    // height: 120vh;
  }
`;

export const PreviewOfPaymentHeader = styled.h3`
  text-align: center;
  padding-top: 10px;
  color: ${colors.NAVYBLUE};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
`;

export const PreviewOfPaymentSubHeader = styled.h3`
  text-align: center;
  color: ${colors.NEUTRAL_GREY};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const PreviewOfPaymentInfo = styled.div`
  padding-bottom: 20px;
  text-align: center;
  color: ${colors.BLACK};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold1};
  font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
`;

export const PreviewOfPaymentDetailsModal = styled.div`
  width: 85%;
  // height: 100vh;
  margin: 0 auto;
  background-color: white;
  padding-top: 15px;
  border-radius: 10px;
  box-shadow: 0px 4px 4px 0px #eaeaea40;

  @media screen and (max-width: 1280px) {
    // height: 95vh;
  }

  @media screen and (max-width: 1024px) {
    // height: 740px;
  }

  @media screen and (max-width: 768px) {
    // height: 80vh;
    /* width: 100%; */
  }

  @media screen and (max-width: 390px) {
    // height: 90vh;
  }

  @media screen and (max-width: 375px) {
    // height: 106vh;
  }

  @media screen and (max-width: 360px) {
    // height: 98vh;
  }
`;

export const PreviewEmailContainer = styled.div`
  padding-top: 0px;
  width: 90%;
  padding-left: 15px;
  margin-bottom: 40px;
`;

export const PreviewTaxContainer = styled.div`
  // padding-top: 20px;
  width: 90%;
  padding-left: 15px;
  margin-bottom: 20px;
`;

export const PreviewPhoneContainer = styled.span``;

export const PreviewPhoneBox = styled.span`
  width: 90%;
  padding-left: 15px;
  color: ${colors.BLACK};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const PreviewPaymentPhoneContainer = styled.div`
  display: flex;
  align-items: center;
  width: 90%;
  padding-left: 15px;
  padding-top: 4px;
`;

export const PhoneContainer = styled.div``;

export const PreviewPaymentMainCon = styled.div`
  padding-top: 22px;
  width: 90%;
  padding-left: 16px;
`;

export const SpanStyles = styled.span`
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  padding-left: 18px;
`;

export const PreviewPaymentInputMain = styled.div`
  margin-top: 20px;
`;

export const PreviewPaymentInput1 = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #e8eaed;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 2px 0px 2px 10px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const PreviewPaymentInput2 = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #e8eaed;
  padding: 5px 10px;
  padding: 2px 0px 2px 10px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const PreviewPaymentInput3 = styled.input`
  width: 100%;
  height: 40px;
  border-bottom-left-radius: 10px;
  border: 1px solid #e8eaed;
  padding: 5px 10px;
  padding: 2px 0px 2px 10px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const PreviewPaymentInput4 = styled.input`
  width: 100%;
  height: 40px;
  border-bottom-right-radius: 10px;
  border: 1px solid #e8eaed;
  padding: 5px 10px;
  padding: 2px 0px 2px 10px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const PreviewPaymentContent1 = styled.div`
  width: 90%;
  margin: 0 auto;
  padding-top: 8px;
`;

export const PreviewPaymentContent2 = styled.div`
  width: 90%;
  margin: 0 auto;
`;

export const PreviewPaymentContent3 = styled.div`
  width: 90.2%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-left: 15px;
`;

export const PreviewPaymentButtonContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 30px;
`;

export const PreviewPaymentContent4 = styled.div``;

export const SelectPaymentOptionPaymentLink = styled.div`
  width: 90%;
  padding-left: 29px;
  padding-top: 15px;
`;

export const PaymentWithAccount = styled.div`
  padding-top: 10px;
`;

export const PaymentOptionsSelect = styled.span`
  padding-right: 22px;
  color: ${colors.NEUTRAL_GREY};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const PreviewLargeInput = styled.input`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  margin-left: 8px;
  width: 69%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  -moz-appearance: textfield;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const PreviewSmallInput = styled.input`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  width: 15%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  margin-left: 15px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const RadioButton = styled.input.attrs({ type: "radio" })`
  margin-left: auto;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  position: relative;

  &::before {
    content: "";
    display: inline-block;
    width: ${(props) => (props.checked ? "4px" : "15px")};
    height: ${(props) => (props.checked ? "4px" : "15px")};
    border: 2px solid ${(props) => (props.checked ? "#69c914" : "#CFCFCFCF")};
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: middle;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &::after {
    content: "";
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 1px solid ${(props) => (props.checked ? "#69c914" : "#0056b3")};
    border-radius: 50%;
    vertical-align: middle;
    position: relative;
    z-index: 0;
    opacity: ${(props) => (props.checked ? "1" : "0")};
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &:checked::before {
    border-color: #69c914;
    background-color: #69c914;
  }
`;

// New styled components for the two sections

export const Label = styled.label`
  padding-left: 17px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const PaymentWithCardSpan = styled.span`
  padding-left: 7px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  color: ${colors.NEUTRAL_BLACK};
`;

export const CharityPreviewSubSpan = styled.div`
  text-align: center;
  color: ${colors.NEUTRAL_GREY};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;
